import styled from "styled-components";

export const primary = "#133986";
export const white = "#ffffff";
export const black = "#000000";
export const primary_light = "#0DA6F2";

export const disabledBackground = "#d3d3d3";
export const disabledText = "#9e9e9e";

export const font_size = "16px";
export const font_weight = 400;

export const grey = " #f4f4f4";

export const tablet = "1250px";
export const mobile = "515px";

export const section = styled.div`
  padding: 64px 0px;
  max-width: 1312px;
  width: calc(100% - 216px);
  margin: 0px auto;

  @media (max-width: ${tablet}) {
    width: calc(100% - 88px);
  }

  @media (max-width: ${mobile}) {
    width: calc(100% - 48px);
  }
`;

export const column_align = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* transform: translateY(0px); */

  /* transform: translateY(0px);

  @media (max-width: ${tablet}) {
  }
  @media (max-width: ${mobile}) {
    transform: translateY(0px);
  } */
`;

export const SmallText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  opacity: 0.6;
  @media (max-width: ${mobile}) {
    font-size: 12px;
  }
`;
